import React, {Component} from 'react';
import {NavigationHScroll} from '@homeaway/react-navigation';
import './Hero.less';

class Hero extends Component {
    constructor(props) {
        super(props);
        this.state = {activeIndex: 0};
    }

    handleNavLink = (e, i) => {
        this.setState({activeIndex: i});
    };

    render() {
        const {title, copy, jumpLinks} = this.props;
        const inner = {__html: copy};
        return (
            <div className={`Hero content-padding`}>
                <div className="Hero__inner content-container">
                    <div className="Hero__content">
                        <h1 className="h1--colossal">{title}</h1>
                        <p dangerouslySetInnerHTML={inner} />
                    </div>
                    <div className="Hero__image">
                        <img
                            src={require('../../assets/shield.png')}
                            alt=""
                            className="img-responsive"
                        />
                    </div>
                </div>
                <div className="Hero__bottom-bar content-container">
                    <NavigationHScroll
                        scrollIncrement={400}
                        links={jumpLinks}
                        activeIndex={this.state.activeIndex}
                        onLinkClick={this.handleNavLink}
                    />
                </div>
            </div>
        );
    }
}

export default Hero;
